import {CategoryType} from "../constant/Category.type";

export class FaqDto {
    public seq: number = 0;
    public category: CategoryType = CategoryType.ALL;
    public title: string = "";
    public content: string = "";
}